import { useEffect } from 'react';

import { useGetSitesQuery } from 'data/__generated__';
import { SITES_UPDATED_SUBSCRIPTION } from 'data/subscriptions/site';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';

import { apolloClient } from '../../../App';
import { sitesUpdatedHandler } from '../../Sites/utils/sitesUpdatedHandler';
import { stocksColumns, type StockSiteRow } from '../constants/stocksColumns';

export const StocksList = () => {
    const { loading: sitesLoading, data: sitesData, error: sitesError } = useGetSitesQuery();

    useEffect(() => {
        const observer = apolloClient.subscribe({
            query: SITES_UPDATED_SUBSCRIPTION,
        });
        const subscription = observer.subscribe(({ data }) => {
            const { siteUpdated } = data;
            sitesUpdatedHandler(siteUpdated);
        });

        return () => subscription.unsubscribe();
    }, []);

    if (sitesLoading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (!sitesData || sitesError) {
        throw new Error('Une erreur est survenue lors de la récupération des sites');
    }

    const { sites } = sitesData;

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<StockSiteRow>
                columns={stocksColumns}
                data={sites}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/site/${row._id}/stocks`}
                searchPlaceholder="Nom du site"
                searchFilterKey="searchValue"
            />
        </div>
    );
};
